document.addEventListener('click', (event) => {
	const checkoutButton = document.querySelector('.button.button-1.button-checkout');
	const checkbox = document.querySelector(".rterms-checkbox");

	// Guard clauses: if the checkout button isn't on this page, or the click
	// wasn't on it, do nothing. Prevents "Cannot read properties of null" errors
	// that previously fired on every click across the whole site.
	if (!checkoutButton || !checkoutButton.contains(event.target)) {
		return;
	}

	// Only intercept for the HulkApps draft-order (wholesale/PO) flow, and only
	// when every required piece is present. Otherwise let the normal Shopify
	// checkout submit proceed untouched.
	const isDraftOrder = (typeof is_draft_order !== 'undefined') && is_draft_order;

	if (
		isDraftOrder &&
		typeof window.hulkapps !== 'undefined' && window.hulkapps &&
		checkbox && checkbox.checked &&
		typeof hulkappsCheckout === 'function'
	) {
		event.preventDefault();
		event.stopPropagation();
		event.stopImmediatePropagation();
		hulkappsCheckout();
	}
}, true);
